import axios from "axios";

const staticConfig = {
  tileServer: {
    url: "https://cyberjapandata.gsi.go.jp"
  }
};

const cognitoConfig = {
  Region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_fIFrbbfSx",
  ClientId: "4sngs87d4bikagofhflbaeab2s"
};

const webPushApiStage = process.env.NODE_ENV === "production" ? "prod" : "dev";
const webPushApi = axios.create({
  responseType: "json",
  baseURL: `https://jbzk8hu651.execute-api.ap-northeast-1.amazonaws.com/${webPushApiStage}/api`
});
const webPushTopic =
  process.env.VUE_APP_CHRONOLOGY_ALIAS === "syokuin"
    ? "hodatsushimizu"
    : "hodatsushimizu-dev";

export { staticConfig, cognitoConfig, webPushApi, webPushTopic };
